import { Loader2 } from "lucide-react";
import type { AsyncTask } from "@/modern/components/async-tasks/types";
import { getTaskStatusMessage } from "@/modern/components/async-tasks/utils";

/** Outputs panel row while a DOCX/PDF is generating — driven by AsyncTaskUI.Loader. */
export function MarketingDocumentGeneratingPanelRow({ task }: { task?: AsyncTask }) {
  const label = task ? getTaskStatusMessage(task) : "Generating document…";

  return (
    <div
      className="rounded-lg border border-dashed border-primary/30 bg-primary/5 p-3"
      aria-busy
      aria-label={label}
    >
      <div className="flex items-center gap-2 mb-2">
        <Loader2 className="size-3 shrink-0 animate-spin text-primary/70" aria-hidden />
        <span className="text-[13px] font-medium text-foreground/85 truncate">{label}</span>
      </div>
      <div className="space-y-1.5 pl-5">
        <div className="h-2 max-w-[180px] w-[75%] animate-pulse rounded bg-muted" />
        <div className="h-2 max-w-[100px] w-[45%] animate-pulse rounded bg-muted/70" />
      </div>
      <div className="mt-2.5 flex items-center gap-3 pl-5">
        <div className="h-2 w-14 animate-pulse rounded bg-muted/50" />
        <div className="h-2 w-12 animate-pulse rounded bg-muted/40 ml-auto" />
      </div>
    </div>
  );
}
